import { Box, Typography, Checkbox, FormControlLabel } from "@mui/material";
import { useEffect } from "react";

export default function PublishingSection({
  values = {},
  setValues = () => {},
  isEditing,
}) {

  const isActive = values.shopifyStatus === "ACTIVE";

  useEffect(() => {
    // Si está en DRAFT → desactivar y limpiar publicaciones
    if (!isActive) {
      setValues(prev => ({
        ...prev,
        publications: []
      }));
      return;
    }

    // Si está en modo create y está ACTIVE → setear defaults
    if (!isEditing) {
      if (!values.publications || values.publications.length === 0) {
        setValues(prev => ({
          ...prev,
          publications: ["b2c_onlineStore", "google", "facebook", "pos", "b2b_onlineStore" ]
        }));
      }
      return;
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEditing, isActive]);

  const handlePublicationChange = (channelId) => {
    setValues(prev => {
      const prevPubs = prev.publications || [];
      const exists = prevPubs.includes(channelId);
      return {
        ...prev,
        publications: exists
          ? prevPubs.filter(c => c !== channelId)
          : [...prevPubs, channelId],
      };
    });
  };


  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
        Publishing
      </Typography>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
          gap: 4,
        }}
      >
        {/* B2C Channels */}
        <Box>
          <Typography variant="subtitle2" sx={{ mb: 1 }}>
            Sales channels B2C
          </Typography>

          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            {[
              { id: "b2c_onlineStore", name: "Online Store" },
              { id: "google", name: "Google & YouTube" },
              { id: "facebook", name: "Facebook & Instagram" },
              { id: "pos", name: "Point of Sale" },
            ].map((channel) => (
              <FormControlLabel
                key={channel.id}
                control={
                  <Checkbox
                    checked={isActive && values.publications?.includes(channel.id)}
                    disabled={!isActive}
                    onChange={() => handlePublicationChange(channel.id)}
                  />
                }
                label={channel.name}
              />
            ))}
          </Box>
        </Box>

        {/* B2B Channels */}
        <Box>
          <Typography variant="subtitle2" sx={{ mb: 1 }}>
            Sales channels B2B
          </Typography>

          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={isActive && values.publications?.includes("b2b_onlineStore")}
                  disabled={!isActive}
                  onChange={() => handlePublicationChange("b2b_onlineStore")}
                />
              }
              label="Online Store"
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}